import type { ReactNode } from "react";

export type BadgeTone = "neutral" | "ok" | "danger" | "warn" | "info";

const tones: Record<BadgeTone, string> = {
  neutral: "border-line bg-line/30 text-ink-muted",
  ok: "border-brand/40 bg-brand/15 text-brand",
  danger: "border-danger/40 bg-danger/15 text-danger",
  warn: "border-warn/40 bg-warn/15 text-warn",
  info: "border-ink-muted/40 bg-ink-muted/10 text-ink",
};

export interface BadgeProps {
  tone?: BadgeTone;
  dot?: boolean;
  children: ReactNode;
}

/** Único componente de etiqueta/estado do sistema. */
export default function Badge({ tone = "neutral", dot = false, children }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border px-2.5 py-0.5 font-mono text-[11px] uppercase tracking-wide ${tones[tone]}`}
    >
      {dot && <span className="size-1.5 rounded-full bg-current" />}
      {children}
    </span>
  );
}

/** Mapeia o status de um projeto/deploy para o tom da etiqueta. */
export function statusTone(status: string): BadgeTone {
  switch (status) {
    case "ready":
    case "active":
    case "running":
    case "succeeded":
    case "ok":
      return "ok";
    case "failed":
    case "error":
      return "danger";
    case "building":
    case "queued":
    case "draft":
      return "warn";
    case "archived":
      return "neutral";
    default:
      return "info";
  }
}
